import {
	Breadcrumb,
	BreadcrumbEllipsis,
	BreadcrumbItem,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
	HomeBreadcrumbItem,
} from '~/components/localized-breadcrumb'
import { useLingui } from '@lingui/react/macro'

export const SchedulingBreadcrumb = () => {
	const { t } = useLingui()

	return (
		<Breadcrumb>
			<BreadcrumbList>
				<HomeBreadcrumbItem />

				<BreadcrumbSeparator />

				<BreadcrumbItem>
					<BreadcrumbPage>{t`Prise de rendez-vous`}</BreadcrumbPage>
					<BreadcrumbEllipsis className='md:hidden' />
				</BreadcrumbItem>
			</BreadcrumbList>
		</Breadcrumb>
	)
}
